// CertificateIssueRow — one <tr> in CertificatesPage's "Ready to issue"
// table. Same useIssueCertificate hook as the dashboard's list-item version.
import { useIssueCertificate } from "../../hooks/useIssueCertificate.js";
import { formatDate } from "../../lib/formatDateTime.js";
import type { CertificateReady, IssueCertificateResult } from "../../lib/adminCertificateTypes.js";

interface CertificateIssueRowProps {
  item: CertificateReady;
  onIssued: (certificate: IssueCertificateResult) => void;
}

export default function CertificateIssueRow({ item, onIssued }: CertificateIssueRowProps) {
  const { isSubmitting, error, issue } = useIssueCertificate(item.studentId, item.courseId, onIssued);

  return (
    <tr>
      <td className="px-4 py-3">
        <p className="font-medium text-dm-navy">{item.studentName}</p>
        <p className="text-xs text-dm-slate">{item.studentCode}</p>
      </td>
      <td className="px-4 py-3">{item.courseTitle}</td>
      <td className="px-4 py-3">{item.completedAt ? formatDate(item.completedAt) : "—"}</td>
      <td className="px-4 py-3">
        <button
          type="button"
          disabled={isSubmitting}
          onClick={() => void issue()}
          className="rounded-md bg-dm-navy px-3 py-1.5 text-xs font-medium text-white hover:bg-dm-blue disabled:cursor-not-allowed disabled:opacity-50"
        >
          {isSubmitting ? "Issuing…" : "Issue certificate"}
        </button>
        {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
      </td>
    </tr>
  );
}
